export const FormLabelText = {
  TITLE_ORGANISATION: 'Organisation details',
  TITLE_DETAILS: 'Your details',
  COMPANY_LABEL: 'Organisation name',
  STREET_LABEL: 'Street name',
  ZIP_LABEL: 'Postal code',
  FIRST_NAME_LABEL: 'First name',
  LAST_NAME_LABEL: 'Last name',
  EMAIL_LABEL: 'Email address',
  MOBILE_LABEL: 'Mobile number',
  MOBILE_CODE_LABEL: 'Mobile Country Code',
  STREET_ERROR_TEXT: 'Enter a street name',
  ZIP_ERROR_TEXT: 'Enter postal code',
  INDUSTRY_ERROR_TEXT: 'industry',
  REASON_ERROR_TEXT: 'reason for choosing us',
  CITY_ERROR_TEXT: 'city',
  EMPLOYEE_ERROR_TEXT: 'no. of employees'
};
